import IApplicationConfig from '^types/IApplicationConfig';
import UrlResolver from '^utils/urlResolver';

class ApplicationConfig implements IApplicationConfig {
  private readonly _variantCode: string;
  private readonly _backgroundColor?: string;

  private _urlResolver = new UrlResolver();

  private _resolveValue = (name: keyof IApplicationConfig): string => {
    const value = window.xprops.isWidgetMode
      ? window.xprops[name]
      : this._urlResolver.parseUrlSearchParams<string>(name);

    return value ?? '';
  };

  public get variantCode(): string {
    return this._variantCode;
  }
  public get backgroundColor(): string | undefined {
    return this._backgroundColor;
  }

  public constructor() {
    this._variantCode = this._resolveValue('variantCode');
    this._backgroundColor = this._resolveValue('backgroundColor');
  }
}

export default new ApplicationConfig();
